var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState, useEffect, useMemo } from 'react';
import ConstructorIOClient from '@constructor-io/constructorio-client-javascript';
import debounce from 'lodash/debounce';
import Cookie from 'js-cookie';
import { isBrowser } from './ssr';
import { constructorio } from './config';
/**
 * Typeguards for use with ConstructorIO response
 */
export function isSearchResult(response) {
    return response !== null && !(response === null || response === void 0 ? void 0 : response.redirect);
}
export function isRedirectResult(response) {
    return response !== null && (response === null || response === void 0 ? void 0 : response.redirect);
}
// Constructor client-side API cannot be instantiated server-side
var ConstructorClient;
// Check if the code is running in a browser environment
if (isBrowser()) {
    // Function to check if the user has given consent
    var hasConsent_1 = function () {
        // Get the value of the 'OptanonConsent' cookie
        var consentCookie = Cookie.get('OptanonConsent');
        // Check if "consentCookie" contains "C0063:1 (Performance (advertising/marketing) Vendors/Cookies)"
        return /[,=]C0063:1,/.test(consentCookie || '');
    };
    // Function to initialize the ConstructorIO client
    var initializeConstructorClient = function () {
        // Get the value of the 'BOM-USER' cookie
        var bomUser = Cookie.get('BOM-USER');
        // Parse the cookie value to get the user ID
        var userId = bomUser ? JSON.parse(bomUser).bombasId : undefined;
        // Define the options for the ConstructorIO client
        var options = {
            apiKey: constructorio.API_INDEX_KEY,
            // If the user has given consent and a user ID is available, use it. Otherwise, leave it undefined.
            userId: userId && hasConsent_1() ? userId : undefined
        };
        // Create a new ConstructorIO client with the defined options
        ConstructorClient = new ConstructorIOClient(options);
    };
    // Initialize the ConstructorIO client
    initializeConstructorClient();
}
export var ConstructorIOContext = React.createContext(null);
var ConstructorIOProvider = function (_a) {
    var children = _a.children, _b = _a.resultsPerPage, resultsPerPage = _b === void 0 ? 20 : _b, _c = _a.initialQuery, initialQuery = _c === void 0 ? '' : _c, _d = _a.isSearchPage, isSearchPage = _d === void 0 ? false : _d;
    var _e = useState(1), page = _e[0], setPage = _e[1];
    var _f = useState([]), results = _f[0], setResults = _f[1];
    var _g = useState(''), resultId = _g[0], setResultId = _g[1];
    var _h = useState([]), recommendations = _h[0], setRecommendations = _h[1];
    var _j = useState(null), response = _j[0], setResponse = _j[1];
    var _k = useState(initialQuery), query = _k[0], setQuery = _k[1];
    var hasMoreResults = page * resultsPerPage < (response === null || response === void 0 ? void 0 : response.total_num_results);
    var refreshResults = useMemo(function () {
        return debounce(function (search) { return __awaiter(void 0, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!search.length) return [3 /*break*/, 2];
                        return [4 /*yield*/, ConstructorClient.search.getSearchResults(search, {
                                resultsPerPage: resultsPerPage
                            })];
                    case 1:
                        res = _a.sent();
                        setPage(1);
                        setResponse(res.response);
                        setResultId(res.result_id);
                        if (isSearchResult(res.response)) {
                            setResults(res.response.results);
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); }, 175);
    }, [ConstructorClient]);
    var refreshResultsAutocomplete = useMemo(function () {
        return debounce(function (search) { return __awaiter(void 0, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!search.length) return [3 /*break*/, 2];
                        return [4 /*yield*/, ConstructorClient.autocomplete.getAutocompleteResults(search, {
                                resultsPerSection: {
                                    Products: 4,
                                    'Search Suggestions': 5
                                }
                            })];
                    case 1:
                        res = _a.sent();
                        setResponse(res);
                        setRecommendations(res.sections['Search Suggestions']);
                        setResults(res.sections.Products);
                        setResultId(res.result_id);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); }, 175);
    }, [ConstructorClient]);
    var loadNextPage = function () { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!hasMoreResults)
                        return [2 /*return*/];
                    return [4 /*yield*/, ConstructorClient.search.getSearchResults(query, {
                            resultsPerPage: resultsPerPage,
                            page: page + 1
                        })];
                case 1:
                    result = _a.sent();
                    if (result) {
                        setPage(page + 1);
                        setResults(__spreadArray(__spreadArray([], results, true), result.response.results, true));
                        setResultId(result.result_id);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        // Clear response immediately when query has been removed
        if (!query.length) {
            setResponse(null);
            setResultId('');
        }
        else if (!isSearchPage)
            refreshResultsAutocomplete(query);
    }, [query, isSearchPage]);
    useEffect(function () {
        if (!isSearchPage) {
            ConstructorClient.recommendations
                .getRecommendations('bestsellers_products', {
                section: 'Products',
                numResults: 4
            })
                .then(function (res) {
                setResponse(res.response);
                if (isSearchResult(res.response)) {
                    setResults(res.response.results);
                }
            });
            ConstructorClient.recommendations
                .getRecommendations('bestsellers_search_suggestions', {
                section: 'Search Suggestions',
                numResults: 5
            })
                .then(function (res) {
                setRecommendations(res.response.results);
            });
        }
    }, [isSearchPage]);
    // useEffect to listen when is a Search Page and trigger refreshResults so the search page can have the correct structure with the redirect property to display the page title and results
    useEffect(function () {
        if (isSearchPage) {
            refreshResults(query);
        }
    }, [isSearchPage]);
    return (React.createElement(ConstructorIOContext.Provider, { value: {
            query: query,
            setQuery: setQuery,
            response: response,
            results: results,
            resultId: resultId,
            recommendations: recommendations,
            loadNextPage: loadNextPage,
            hasMoreResults: hasMoreResults
        } }, children));
};
/**
 * Custom hook for using ConstructorIO API
 */
export var useConstructorIO = function () {
    var context = React.useContext(ConstructorIOContext);
    if (context === null) {
        if (process.env.NODE_ENV === 'test') {
            throw new Error("Attempting to useConstructorIO in a testing environment.\n\n        Instead, you might want to automock 'useConstructorIO' hook.\n\n        Example: jest.mock('../util/ConstructorIO.context')");
        }
        throw new Error('useConstructorIO must be used within a ConstructorIOProvider');
    }
    return context;
};
export default ConstructorIOProvider;
